module.exports = __webpack_public_path__ + "img/No_Image_Available.625d1aff.jpg";